interface EventCategory {
  eventCategoryCode: string
  eventCategory: string
}

interface EventClass {
  eventClassCode: string
  eventClass: string
  categories: Record<string, EventCategory>
}

const TrackEventData: Record<string, EventClass> = {
  event_Login: {
    eventClassCode: 'event_Login',
    eventClass: '登录事件',
    categories: {
      Account_Login: {
        eventCategoryCode: 'Account_Login',
        eventCategory: '登录账号',
      },
      Account_Switch: {
        eventCategoryCode: 'Account_Switch',
        eventCategory: '切换账号',
      },
    },
  },
  event_LoginAndLogout: {
    eventClassCode: 'event_LoginAndLogout',
    eventClass: '登入登出事件',
    categories: {
      Page_Wakeup: {
        eventCategoryCode: 'Page_Wakeup',
        eventCategory: '唤醒页面',
      },
      Page_Hibernate: {
        eventCategoryCode: 'Page_Hibernate',
        eventCategory: '休眠页面',
      },
    },
  },
  event_MenusBrowsing: {
    eventClassCode: 'event_MenusBrowsing',
    eventClass: '菜单浏览事件',
    categories: {
      Page_Jumpto: {
        eventCategoryCode: 'Page_Jumpto',
        eventCategory: '页面跳转',
      },
      Page_Switch: {
        eventCategoryCode: 'Page_Switch',
        eventCategory: '页面切换',
      },
    },
  },
  event_ElementClick: {
    eventClassCode: 'event_ElementClick',
    eventClass: '元素点击事件',
    categories: {
      Button: {
        eventCategoryCode: 'Button',
        eventCategory: '按钮',
      },
      SuperLink: {
        eventCategoryCode: 'SuperLink',
        eventCategory: '超链接',
      },
      Icon_Button: {
        eventCategoryCode: 'Icon_Button',
        eventCategory: '图标按钮',
      },
      Module: {
        eventCategoryCode: 'Module',
        eventCategory: '板块',
      },
      Label: {
        eventCategoryCode: 'Label',
        eventCategory: '标签',
      },
    },
  },
  event_ComponentOperation: {
    eventClassCode: 'event_ComponentOperation',
    eventClass: '组件操作事件',
    categories: {
      Input: {
        eventCategoryCode: 'Input',
        eventCategory: '输入框',
      },
      Pull_Down: {
        eventCategoryCode: 'Pull_Down',
        eventCategory: '下拉选择器',
      },
      Time: {
        eventCategoryCode: 'Time',
        eventCategory: '时间选择器',
      },
      Radio_Button: {
        eventCategoryCode: 'Radio_Button',
        eventCategory: '单选按钮',
      },
      Pagination: {
        eventCategoryCode: 'Pagination',
        eventCategory: '分页组件',
      },
      Check: {
        eventCategoryCode: 'Check',
        eventCategory: '勾选组件',
      },
      Sort: {
        eventCategoryCode: 'Sort',
        eventCategory: '排序组件',
      },
      Multi_Condition: {
        eventCategoryCode: 'Multi_Condition',
        eventCategory: '多条件搜索',
      },
    },
  },
  event_CodeScanning: {
    eventClassCode: 'event_CodeScanning',
    eventClass: '扫码事件',
    categories: {
      Wechat_QRCode: {
        eventCategoryCode: 'Wechat_QRCode',
        eventCategory: '微信二维码',
      },
      Payment_QRCode: {
        eventCategoryCode: 'Payment_QRCode',
        eventCategory: '付款码',
      },
      Platform_QRCode: {
        eventCategoryCode: 'Platform_QRCode',
        eventCategory: '小程序公众号',
      },
    },
  },
  event_Recharge: {
    eventClassCode: 'event_Recharge',
    eventClass: '充值事件',
    categories: {
      Alipay: {
        eventCategoryCode: 'Alipay',
        eventCategory: '支付宝',
      },
      Wechatpay: {
        eventCategoryCode: 'Wechatpay',
        eventCategory: '微信',
      },
    },
  },
  event_Payment: {
    eventClassCode: 'event_Payment',
    eventClass: '支付事件',
    categories: {
      Order_Payment: {
        eventCategoryCode: 'Order_Payment',
        eventCategory: '订单支付',
      },
    },
  },
  event_RequestException: {
    eventClassCode: 'event_RequestException',
    eventClass: '请求异常事件',
    categories: {
      Data_Exception: {
        eventCategoryCode: 'Data_Exception',
        eventCategory: '数据异常',
      },
      Network_Exception: {
        eventCategoryCode: 'Network_Exception',
        eventCategory: '网络异常',
      },
    },
  },
}

const TrackEventFlatMap = Object.entries(TrackEventData).reduce<Record<string, FlatTrackEvent>>(
  (acc, [classKey, eventClass]) => {
    Object.entries(eventClass.categories).forEach(([catKey, category]) => {
      acc[category.eventCategoryCode] = {
        eventCategoryCode: category.eventCategoryCode,
        eventCategory: category.eventCategory,
        eventClassCode: eventClass.eventClassCode,
        eventClass: eventClass.eventClass,
      }
    })
    return acc
  },
  {},
)

export { TrackEventData, TrackEventFlatMap }
